import { uid } from '@fiverr-private/futile';

/**
 * Generate a unique audition ID
 * @desc Returns a randomized UUID
 * @returns {string} - The audition ID generated (UUID)
 */
export const generateAuditionId = () => uid();
